/**
 * Returns a URL for a named asset.
 * In production (WP), assets are served from the plugin's /assets/ folder via assetsUrl.
 * In dev mode (Vite dev server), assets are bundled and importable directly.
 */
export const getAssetUrl = (filename: string): string => {
  const assetsUrl = window.campaignParams?.assetsUrl
  if (assetsUrl) {
    return `${assetsUrl.replace(/\/$/, '')}/${filename}`
  }
  // Fallback: shouldn't happen when loaded via WP shortcode
  return `/${filename}`
}
